// Write your JS code here
import './index.css'

const Home = () => (
  <div className="route-container">
    <img
      src="https://assets.ccbp.in/frontend/react-js/home-blog-img.png"
      alt="home"
      className="route-image"
    />
    <h1 className="route-heading">Home</h1>
  </div>
)

export default Home
